import { heroLines } from '@/mocks/home';

interface HeroProps {
  onEnter: (message: string) => void;
}

const metaChips = ['无需注册', '免搜索直达', '全终端可用', '自动跳转'];

export default function Hero({ onEnter }: HeroProps) {
  return (
    <section className="relative overflow-hidden border-b border-background-200 bg-background-50">
      <div className="pointer-events-none absolute inset-0">
        <div className="absolute -left-24 -top-24 h-72 w-72 rounded-full bg-primary-100/70 blur-3xl"></div>
        <div className="absolute right-0 top-10 h-72 w-72 rounded-full bg-accent-100/60 blur-3xl"></div>
      </div>

      <div className="relative mx-auto w-full max-w-[1200px] px-4 py-14 md:px-6 md:py-20">
        <div className="grid grid-cols-1 items-center gap-10 lg:grid-cols-12">
          <div className="lg:col-span-7 animate-fade-up">
            <span className="inline-flex items-center gap-2 rounded-full border border-primary-200 bg-primary-50 px-3 py-1 text-xs text-primary-700">
              <span className="flex h-4 w-4 items-center justify-center">
                <i className="ri-flashlight-line"></i>
              </span>
              秒进直达 · 免搜索入口
            </span>

            <h2 className="mt-5 font-heading text-4xl leading-tight text-foreground-950 md:text-6xl">
              要的就是快，
              <br />
              点开就是入口
            </h2>

            <p className="mt-5 max-w-2xl text-base leading-8 text-foreground-700 md:text-lg">
              要的就是快，黑料入口跳转与秒进直达链接都在这，一键进入快速访问，省去搜索等待时间，点开直接跳转开吃瓜看黑料。
            </p>

            <div className="mt-8 flex flex-col gap-3 sm:flex-row">
              <button
                type="button"
                onClick={() => onEnter('已为你打开主线路入口（演示）')}
                className="inline-flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm text-background-50 transition hover:bg-primary-600"
              >
                <i className="ri-flashlight-fill text-base"></i>
                一键进入
              </button>
              <a
                href="#entry"
                className="inline-flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md border border-secondary-300 bg-background-50 px-6 py-3 text-sm text-foreground-800 transition hover:bg-secondary-100"
              >
                <i className="ri-route-line text-base"></i>
                查看备用线路
              </a>
            </div>

            <ul className="mt-7 flex flex-wrap items-center gap-x-5 gap-y-2 text-xs text-foreground-600 md:text-sm">
              {metaChips.map((chip) => (
                <li key={chip} className="flex items-center gap-1.5">
                  <span className="flex h-4 w-4 items-center justify-center text-accent-600">
                    <i className="ri-check-line"></i>
                  </span>
                  {chip}
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-5">
            <div className="animate-float-soft rounded-lg border border-background-200 bg-background-50/90 p-5 backdrop-blur">
              <div className="flex items-center justify-between">
                <h3 className="font-heading text-lg text-foreground-950">实时线路状态</h3>
                <span className="flex items-center gap-1.5 text-xs text-foreground-500">
                  <span className="h-1.5 w-1.5 animate-pulse-dot rounded-full bg-accent-500"></span>
                  刚刚更新
                </span>
              </div>

              <ul className="mt-4 space-y-2.5">
                {heroLines.map((line) => (
                  <li
                    key={line.id}
                    className="flex items-center justify-between rounded-md border border-background-200 bg-background-100/60 px-3 py-2.5"
                  >
                    <span className="flex min-w-0 items-center gap-2">
                      <span
                        className={
                          line.tone === 'good'
                            ? 'h-2 w-2 shrink-0 rounded-full bg-accent-500'
                            : 'h-2 w-2 shrink-0 rounded-full bg-primary-500'
                        }
                      ></span>
                      <span className="truncate text-sm text-foreground-800">{line.name}</span>
                    </span>
                    <span className="flex shrink-0 items-center gap-3">
                      <span className="text-xs text-foreground-500">{line.latency}</span>
                      <span
                        className={
                          line.tone === 'good'
                            ? 'rounded-full bg-accent-100 px-2 py-0.5 text-[11px] text-accent-900'
                            : 'rounded-full bg-primary-100 px-2 py-0.5 text-[11px] text-primary-800'
                        }
                      >
                        {line.status}
                      </span>
                    </span>
                  </li>
                ))}
              </ul>

              <div className="mt-4 rounded-md bg-secondary-100/70 px-3 py-2 text-xs text-secondary-900">
                当前推荐：主线路（延迟 0.6s），点「一键进入」即可秒进。
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}